import { Link } from 'react-router-dom';
import { Stack } from 'react-bootstrap';
import usePermission from '../../hooks/usePermission';

export default function NoPermissionPage() {
  const { has } = usePermission();

  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem'
      }}
    >
      <Stack gap={3} className="align-items-center">
        <div>
          <i className="ti ti-lock" style={{ fontSize: '4rem', color: '#d9534f' }}></i>
        </div>

        <h2 className="fw-bold">Access Denied</h2>
        <p className="text-muted" style={{ maxWidth: 420 }}>
          You do not have permission to view this page. Please contact your administrator if you think this is a mistake.
        </p>

        {/* Only for users who may open the dashboard; for the rest it would
            just lead to this page again. */}
        {has('dashboard_access') && (
          <Link to="/" className="btn btn-primary">
            Go to Dashboard
          </Link>
        )}
      </Stack>
    </div>
  );
}
